var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgN(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "N",
    transform: "translate(13239 17249)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4020",
    "data-name": "Rectangle 4020",
    width: 60,
    height: 60,
    transform: "translate(-13239 -17249)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-notifications-7775559",
    transform: "translate(-13246 -17254.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6402",
    "data-name": "Path 6402",
    d: "M57.434,47.877a14.689,14.689,0,0,1-2.919-8.76V29.488A17.411,17.411,0,0,0,38.363,12.143V9.609a1.242,1.242,0,1,0-2.485,0v2.533A17.409,17.409,0,0,0,19.727,29.488v9.629a14.711,14.711,0,0,1-2.919,8.76,4.037,4.037,0,0,0,3.23,6.46h9.741a7.446,7.446,0,0,0,14.685,0l9.741,0a4.038,4.038,0,0,0,3.23-6.462ZM22.212,29.5a14.909,14.909,0,0,1,29.818,0v9.629a17.087,17.087,0,0,0,.844,5.28H21.367a17.088,17.088,0,0,0,.844-5.28ZM37.121,58.071a4.975,4.975,0,0,1-4.807-3.727h9.609a4.965,4.965,0,0,1-4.8,3.727ZM54.2,51.859H20.038A1.553,1.553,0,0,1,18.8,49.374a17.157,17.157,0,0,0,1.541-2.485h33.57a16.735,16.735,0,0,0,1.541,2.485A1.553,1.553,0,0,1,54.2,51.859Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgN);
export default __webpack_public_path__ + "static/media/N.cebc59926556e9ac423475b4c6ee601a.svg";
export { ForwardRef as ReactComponent };